<template>
  <el-dialog style='z-index:5000' :title='config.title' :visible.sync='config.active' :width='config.width' :close-on-click-modal="false">
    <component :is="config.component"></component>

    <span v-if="!config.buttons" slot="footer" class="dialog-footer">
      <el-button @click="config.active = false">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: 'Dialog',
  props: {
    config:Object
  },
  watch:{
    'config.active': function(){
      this.config.afterClose()
    }
  },
  methods: {
    handleConfirm(){
      this.config.component().then(res => {
        res.default.methods.handleConfirm()
      })
    }
  },
  mounted() {
    console.log(this.config)
  }


}

</script>

